<template>
	<div class="image-gallery">
    <flickity @init="getActiveSlide()" class="image-gallery__slider" ref="flickity" :options="flickityOptions">
        <div class="carousel-cell"
          v-for="(thumb, thumbIndex) in images.edges"
          :key="thumbIndex"
        >
          <img :src="thumb.node.imageUrl">
        </div>
    </flickity>

    <div class="image-gallery__buttons">
      <ButtonPrimary v-if="organisation === 'Nhood'"
          :title="$store.getters.language.view_floorplan"
          @buttonClick="openModal(null , 'map')"
      />
      <ButtonPrimary :title="$store.getters.language.space_dimensions" @buttonClick="openModal(`<img src='${listing.blueprintImageUrl}'>`)" v-if="listing.blueprintImageUrl"></ButtonPrimary>
      <ButtonPrimary :title="$store.getters.language.view_floorplan" @buttonClick="openModal(`<img src='${listing.floorplanImageUrl}'>`, 'img')" v-if="listing.floorplanImageUrl && organisation !== 'Nhood'"></ButtonPrimary>
    </div>

    <SpacesModal v-if="modal.visible" @close="modal.visible = false, modal.description = null" :description="modal.description" :large="true"></SpacesModal>

    <SpacesModal v-if="modal.visible && modal.type === 'img'" @close="modal.visible = false, modal.description = null" :description="modal.description" :large="true"></SpacesModal>

    <SpacesModal v-if="modal.visible && modal.type === 'map'" @close="modal.visible = false, modal.description = null" :description="modal.description" :large="true">
      <mapplic-map id="space-map" :data-json="`https://mapplic.com/getMapData?id=${mapId}`"></mapplic-map>
    </SpacesModal>

	</div>
</template>

<script>
// @ is an alias to /src
import Flickity from 'vue-flickity';
import imagesLoaded from 'imagesloaded';
import SpacesModal from "../../components/search/SpacesModal"
import ButtonPrimary from "../../components/global/ButtonPrimary"

export default {
  name: 'MobileSlider',
  data() {
    return {
      organisation: null,
      mapId: 'dWwYd277zQZwgiUUuvur',
      modal: {
        visible: false,
        type: null,
        description: null
      },
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        on: {
          ready: () => { imagesLoaded(this.$refs.flickity, this.loadComplete) }
        }
      }
    }
  },
  components: {
    Flickity,
    SpacesModal,
     ButtonPrimary
  },
  props: {
    images: {
      default: null,
      type: Object
    },
    listing: {
      default: null,
      type: Object
    },
    space_id: {
      type: String
    },
    iframe_embed: {
      type: String
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.mapId = this.iframe_embed
    this.organisation = organisation
  },
  methods: {
    openModal (description, type) {
      this.modal.visible = true
      this.modal.type = type
      this.modal.description = description

      if (this.modal.type === 'map') {
        this.openLocation()
      }
    },
    openLocation () {
      this.$nextTick(() => {
        const map = document.getElementById('space-map')
        map.addEventListener('mapReady', e => {

          const store = map.store
          setTimeout (() => {
            store.getState().openLocation(this.space_id)
          }, 2000)
        })
      })
    },
    loadComplete () {
      if (this.$refs.flickity) {
        this.$refs.flickity.reloadCells()
      }
    },
    getActiveSlide () {
      this.$refs.flickity.resize()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped="true">
@import "../../scss/global/includes";

.image-gallery {
  display: none;
  width: 100vw;
  position: relative;

  @include breakpoint(tablet-landscape) {
    display: block;
  }

  ::v-deep .flickity-prev-next-button.previous {
  }

  ::v-deep .flickity-prev-next-button.next {
  }

  ::v-deep .flickity-prev-next-button {
    width: 40px;
    height: 40px;
  }

  ::v-deep .flickity-button {
    background: transparent;
    svg path {
      fill: #FFFFFF;
    }
  }

}

.image-gallery__slider {

  .carousel-cell {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    overflow: hidden;
    img {
      aspect-ratio: 16/10;
      height: 100%;
      width: 100%;
      object-fit: cover;
      display: block;
    }
  }

}

.image-gallery__buttons {
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 4px;
}

</style>
